import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ScUserService } from 'src/app/core/services/sc/sc-user.service';
import { TranslateConfigService } from 'src/app/core/services/translate-config.service';
import { UserTokenService } from 'src/app/core/services/user-token.service';
import { ScUserMessageInput, ScUserOutput } from 'src/app/models/response/sc-user.model';
import { WoOrderOutput } from 'src/app/features/wo-order/wo-order.model';

@Component({
  selector: 'app-sc-user-message-send',
  //standalone: true,
  //imports: [],
  templateUrl: './sc-user-message-send.component.html',
  styleUrl: './sc-user-message-send.component.scss'
})
export class ScUserMessageSendComponent implements OnInit {

  public message: string = "";
  public language: string = "pt-BR";
  @Input() woOrder: WoOrderOutput = {};
  @Input() clientName!: string;
  @Input() userName!: string;
  payload!: ScUserMessageInput;
  isClient!: boolean;
  @Output() chosedItem = new EventEmitter();
  @Input() listUser: ScUserOutput [] = [];
  @Input() sourceUserId!: string; // User who sent the message
  selectedUser!: ScUserOutput;
  loadingUser: boolean = false;

  constructor(private userTokenService: UserTokenService,
              private userService: ScUserService,
              private translateService: TranslateService,
              private translateConfigService: TranslateConfigService,
              private messageService: MessageService) { }

  ngOnInit(): void {
    this.loadingUser = true;
    this.isClient = this.userTokenService.hasPermissionArray(['ROLE_CLIENT']);
    // Initialize component state or fetch data if needed
    this.translate();
    setTimeout(() => {
      if (this.sourceUserId) {
        this.listUser = this.listUser.filter(user => user.id === this.sourceUserId);
        this.selectedUser = this.listUser[0];
      }
    }, 2000);
    this.loadingUser = false;
  }

  translate() {
    this.language = this.translateConfigService.getLanguage();
  }

  sendMessage() {
    // Logic to send the message
    console.log("Message sent:", this.message);
  }

  resetForm() {
    this.message = "";
  }

  cancel() {
    this.message = "";
    this.chosedItem.emit();
  }

  save() {
    this.payload = {
      message: this.message,
      woOrderId: this.woOrder.id,
      userId: this.userTokenService.getUserId(),
      isEmailProcessing: true,
      isProcessingStatusEmail: "OK",
      targetUserId: this.isClient ? this.woOrder.scUserId : this.woOrder.scClientRequestedId,
      sourceUserId: this.userTokenService.getUserId(),
      isSendNotification: false,
      processingStatus: "OK",
      telephone: this.woOrder.clientTelephone,
      email: null,
      language: this.language,
      parameter: null
    };

    this.userService.addUserMessage(this.payload)
      .subscribe((res) => {
        this.messageSuccess('message.send_success');
        this.message = '';
        this.chosedItem.emit();
      },
    error => {
        console.error('Error sending message:', error);
        this.messageError('message.send_error');
      });
  }

  messageSuccess(message: string) {
    this.messageService.add({ severity: 'success', summary: this.translateService.instant('title.success'), detail: this.translateService.instant(message), life: 3000 });
  }

  messageError(message: string) {
    this.messageService.add({ severity: 'warn', summary: this.translateService.instant('title.error'), detail: this.translateService.instant(message), life: 3000 });
  }

  onChangerUser(user: ScUserOutput) {
    this.selectedUser = user;
    this.clientName = user.name;
    this.userName = user.name;
    this.woOrder.scUserId = user.id;
    this.woOrder.scClientRequestedId = user.id;
  }

}
